import { Component, OnInit } from '@angular/core';
import { Ng7BootstrapBreadcrumbService } from 'ng7-bootstrap-breadcrumb';
import { CategoriaConteudoService } from "../../../configuracoes/categoria-conteudo/categoria-conteudo.service";
import { NotificationsService } from 'src/app/shared/notifications.service';

@Component({
  selector: 'app-last-releases',
  templateUrl: './last-releases.component.html',
  styleUrls: ['./last-releases.component.scss']
})
export class LastReleasesComponent implements OnInit {
  lastRelease: any = []

  constructor(
    private ng7BootstrapBreadcrumbService: Ng7BootstrapBreadcrumbService,
    public categoriaConteudoService: CategoriaConteudoService,
    private notifyService: NotificationsService,) { }

  ngOnInit(): void {
    const breadcrumbs = [
      { label: 'Sesc Digital', url: '/', params: [] },
			{ label: 'Editar destaque últimos lançamentos', url: '', params: [] },
			]
		  
		this.ng7BootstrapBreadcrumbService.updateBreadcrumb(breadcrumbs);

    this.categoriaConteudoService.getFunctionality(2).subscribe(res => {
      this.lastRelease = res;
     
      if(this.lastRelease.id === null){
        this.lastRelease.id = 2;
      }

      if(this.lastRelease.description === null){
        this.lastRelease.description = 'Últimos lançamentos';
      }
    })


  }

  changeStatusLast(){
    setTimeout(() => {
      this.categoriaConteudoService.postFunctionality(this.lastRelease).subscribe(res => {
        this.notifyService.showSuccess(`Sucesso`, 'Editar Lançamentos');
        setTimeout(() => {
          location.reload();
        }, 1000)
      },
      error => {
        this.notifyService.showError('Ocorreu um erro ao editar lançamentos', 'Editar lançamentos');
      })
    }, 200)
  }

}
